import { Environment } from '@bg-shared/enums';

const HOTJAR_ENVIRONMENTS: ReadonlySet<string> = new Set([
    Environment.INTEGRATIONS,
    Environment.PROD_BALTNETA,
    Environment.PROD_AZURE_CAP,
    Environment.PROD_AZURE_GLS,
]);
const HOTJAR_ID = 3765406;
const HOTJAR_SNIPPET_VERSION = 6;

const appendScript = (src: string): HTMLScriptElement => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;
    document.head.appendChild(script);

    return script;
};

const loadHotjar = (): void => {
    const queue: unknown[][] = [];

    Object.assign(window, {
        hj: window.hj || Object.assign((...args: unknown[]) => queue.push(args), { q: queue }),
        _hjSettings: { hjid: HOTJAR_ID, hjsv: HOTJAR_SNIPPET_VERSION },
    });
    appendScript(`https://static.hotjar.com/c/hotjar-${HOTJAR_ID}.js?sv=${HOTJAR_SNIPPET_VERSION}`);
};

const loadSentry = (
    { dsn, tracesSampleRate }: NonNullable<IGlobalConfig['sentry']>,
    environment: string,
): void => {
    const script = appendScript('https://browser.sentry-cdn.com/9.6.0/bundle.tracing.min.js');

    script.crossOrigin = 'anonymous';
    script.onload = () => {
        try {
            Sentry.init({ dsn, tracesSampleRate, release: _sentryRelease, environment });
        } catch (error) {
            console.error('Error loading Sentry: ', error);
        }
    };
    script.onerror = (error) => {
        console.log('Error loading Sentry script', error);
    };
};

export const loadTrackingScripts = (globalConfig: IGlobalConfig): void => {
    if (HOTJAR_ENVIRONMENTS.has(globalConfig.environment)) {
        loadHotjar();
    }

    if (globalConfig.sentry) {
        loadSentry(globalConfig.sentry, globalConfig.environment);
    }
};
